import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    disabled,
    readonly,
    type = 'text',
    autosize = undefined,
    ...args
  }) {
    super(args)
    const child = this.getComponentWithVModel('el-input')
    child.attrs.type = type
    child.attrs.disabled = disabled
    child.attrs.readonly = readonly
    child.attrs.autosize = autosize
    this.children = [child]
  }
}
